import { Tkv2ReferenceBarProperty } from '../../controller/types.js';
import { ReferenceViewIDParsed, formatReferenceViewID } from '../referenceView/index.js';

export const getReferenceProperty = (
  column: 'subject' | string,
  compSeq: string[],
): Tkv2ReferenceBarProperty => {
  const isSubject = ['subject', 'subjectArv'].includes(column);
  const id: ReferenceViewIDParsed =
    isSubject ? { type: 'subject' } : { type: 'comparable', compID: column };
  return {
    id: formatReferenceViewID(id),
    mapPinLabel: isSubject ? '' : (compSeq.indexOf(column) + 1).toFixed(0),
  };
};
